import React, { useState, useEffect } from 'react';
import './NewPreview.scss';

export default function NewPreview(props) {
  props = props.props;
  const [msgLength, setMsgLength] = useState(100);

  const chatData = [
    {
      "TYPE": "bot",
      "MESSAGE": "Hi Sam, I'm Enterprise Bank's virtual assistant. How may I help you?",
      "OPTIONS": [
        "Apply for credit card",
        "Types of accounts",
        "Types of insurance"
      ]
    },{
      "TYPE": "user",
      "MESSAGE": "I lost my card"
    },{
      "TYPE": "bot",
      "MESSAGE": "Sorry I did not understand that, could you please rephrase the question"
    },{
      "TYPE": "notification",
      "MESSAGE": "Agent has joined this conversation."
    },{
      "TYPE": "agent",
      "MESSAGE": "Hi! My name is Sam. How may I help you today?"
    }
  ];

  let chatHeaderStyle = {}, botChatStyleObj = {}, userChatStyleObj = {}, agentChatStyleObj = {}, suggestionsChatStyleObj = {}, inputChatStyleObj = {}, bodythemeObj = {}, fontStyleObj = {}, textAreaStyleObj = {}, themeStyleColor = {}, sendButtonStyle = {};

  const createHexValue = (colorcode, alphavalue) => {
    const r = parseInt(colorcode.slice(1, 3), 16);
    const g = parseInt(colorcode.slice(3, 5), 16);
    const b = parseInt(colorcode.slice(5, 7), 16);

    if (alphavalue) {
        return `rgba(${r}, ${g}, ${b}, ${alphavalue / 100})`;
    } else {
        return `rgb(${r}, ${g}, ${b})`;
    }
  }

  let chatTitle = '',chatTitleImg = '';
  let chatHeaderType = props?.CHAT_HEADER?.TITLE_TYPE?.VALUE;

  if (props && props.THEME_COLOR) {
    chatHeaderStyle = {
      'fontFamily': `${props.FONT.ARRAY[props.FONT.VALUE].NAME}, 'Helvetica Neue', 'Arial', 'Helvetica', 'sans-serif'`,
      'color': props.CHAT_HEADER.FONT_COLOR.VALUE
    };

    botChatStyleObj = {
        'background': props.CHAT_BOT_MESSAGE.BACKGROUND_COLOR.VALUE,
        'color': props.CHAT_BOT_MESSAGE.FONT_COLOR.VALUE,
        'fontSize': props.CHAT_BOT_MESSAGE.FONT_SIZE.VALUE + 'px',
        'boxShadow': `${props.CHAT_BOT_MESSAGE.DROP_SHADOW.VALUE[0].VALUE}px ${props.CHAT_BOT_MESSAGE.DROP_SHADOW.VALUE[1].VALUE}px ${props.CHAT_BOT_MESSAGE.DROP_SHADOW.VALUE[2].VALUE}px ${createHexValue(props.CHAT_BOT_MESSAGE.DROP_SHADOW.VALUE[3].VALUE, props.CHAT_BOT_MESSAGE.DROP_SHADOW.VALUE[4].VALUE)}`,
        'fontFamily': `${props.FONT.ARRAY[props.FONT.VALUE].NAME}, 'Helvetica Neue', 'Arial', 'Helvetica', 'sans-serif'`,
        'outline': `${props.CHAT_BOT_MESSAGE.OUTLINE_COLOR.VALUE ? `${props.CHAT_BOT_MESSAGE.OUTLINE_COLOR.VALUE} solid 1px` : ''}`
    };
    userChatStyleObj = {
        'background': props.USER_MESSAGE.BACKGROUND_COLOR.VALUE,
        'color': props.USER_MESSAGE.FONT_COLOR.VALUE,
        'fontSize': props.USER_MESSAGE.FONT_SIZE.VALUE + 'px',
        'boxShadow': `${props.USER_MESSAGE.DROP_SHADOW.VALUE[0].VALUE}px ${props.USER_MESSAGE.DROP_SHADOW.VALUE[1].VALUE}px ${props.USER_MESSAGE.DROP_SHADOW.VALUE[2].VALUE}px ${createHexValue(props.USER_MESSAGE.DROP_SHADOW.VALUE[3].VALUE, props.USER_MESSAGE.DROP_SHADOW.VALUE[4].VALUE)}`,
        'fontFamily': `${props.FONT.ARRAY[props.FONT.VALUE].NAME}, 'Helvetica Neue', 'Arial', 'Helvetica', 'sans-serif'`,
        'outline': `${props.USER_MESSAGE.OUTLINE_COLOR.VALUE ? `${props.USER_MESSAGE.OUTLINE_COLOR.VALUE} solid 1px` : ''}`
    };
    agentChatStyleObj = {
        'background': props.AGENT_MESSAGE.BACKGROUND_COLOR.VALUE,
        'color': props.AGENT_MESSAGE.FONT_COLOR.VALUE,
        'fontSize': props.AGENT_MESSAGE.FONT_SIZE.VALUE + 'px',
        'boxShadow': `${props.AGENT_MESSAGE.DROP_SHADOW.VALUE[0].VALUE}px ${props.AGENT_MESSAGE.DROP_SHADOW.VALUE[1].VALUE}px ${props.AGENT_MESSAGE.DROP_SHADOW.VALUE[2].VALUE}px ${createHexValue(props.AGENT_MESSAGE.DROP_SHADOW.VALUE[3].VALUE, props.AGENT_MESSAGE.DROP_SHADOW.VALUE[4].VALUE)}`,
        'fontFamily': `${props.FONT.ARRAY[props.FONT.VALUE].NAME}, 'Helvetica Neue', 'Arial', 'Helvetica', 'sans-serif'`,
        'outline': `${props.AGENT_MESSAGE.OUTLINE_COLOR.VALUE ? `${props.AGENT_MESSAGE.OUTLINE_COLOR.VALUE} solid 1px` : ''}`
    };
    suggestionsChatStyleObj = {
        'background': props.SUGGESTIONS.BACKGROUND_COLOR.VALUE,
        'color': props.SUGGESTIONS.FONT_COLOR.VALUE,
        'fontSize': props.SUGGESTIONS.FONT_SIZE.VALUE + 'px',
        'boxShadow': `${props.SUGGESTIONS.DROP_SHADOW.VALUE[0].VALUE}px ${props.SUGGESTIONS.DROP_SHADOW.VALUE[1].VALUE}px ${props.SUGGESTIONS.DROP_SHADOW.VALUE[2].VALUE}px ${createHexValue(props.SUGGESTIONS.DROP_SHADOW.VALUE[3].VALUE, props.SUGGESTIONS.DROP_SHADOW.VALUE[4].VALUE)}`,
        'fontFamily': `${props.FONT.ARRAY[props.FONT.VALUE].NAME}, 'Helvetica Neue', 'Arial', 'Helvetica', 'sans-serif'`,
        'outline': `${props.SUGGESTIONS.OUTLINE_COLOR.VALUE ? `${props.SUGGESTIONS.OUTLINE_COLOR.VALUE} solid 1px` : ''}`
    };
    inputChatStyleObj = {
        'background': props.TEXT_INPUT_AREA.BACKGROUND_COLOR.VALUE,
        'color': props.TEXT_INPUT_AREA.FONT_COLOR.VALUE,
        'fontSize': props.TEXT_INPUT_AREA.FONT_SIZE.VALUE + 'px',
        // 'boxShadow': `${props.TEXT_INPUT_AREA.DROP_SHADOW.VALUE[0].VALUE}px ${props.TEXT_INPUT_AREA.DROP_SHADOW.VALUE[1].VALUE}px ${props.TEXT_INPUT_AREA.DROP_SHADOW.VALUE[2].VALUE}px ${createHexValue(props.TEXT_INPUT_AREA.DROP_SHADOW.VALUE[3].VALUE, props.TEXT_INPUT_AREA.DROP_SHADOW.VALUE[4].VALUE)}`,
        'fontFamily': `${props.FONT.ARRAY[props.FONT.VALUE].NAME}, 'Helvetica Neue', 'Arial', 'Helvetica', 'sans-serif'`
    };

    bodythemeObj = {
        'background': props.CHAT_WINDOW_BACKGROUND_COLOR.VALUE
    };

    fontStyleObj = {
        'fontFamily': `${props.FONT.ARRAY[props.FONT.VALUE].NAME}, 'Helvetica Neue', 'Arial', 'Helvetica', 'sans-serif'`
    }

    textAreaStyleObj = {
        'fontSize': props.TEXT_INPUT_AREA.FONT_SIZE.VALUE,
        'fontFamily': `${props.FONT.ARRAY[props.FONT.VALUE].NAME}, 'Helvetica Neue', 'Arial', 'Helvetica', 'sans-serif'`
    }

    themeStyleColor = {
      'background': props.THEME_COLOR.VALUE
    }

    sendButtonStyle = {
      'background': props.TEXT_INPUT_AREA.SEND_BUTTON_COLOR.VALUE,
      'color': props?.TEXT_INPUT_AREA?.SEND_ICON_COLOR?.VALUE ? props.TEXT_INPUT_AREA.SEND_ICON_COLOR.VALUE : props.TEXT_INPUT_AREA.ICON_COLOR.VALUE
    }
  }

  const renderChatHeader = () => {
    if(chatHeaderType === 'Text') {
      chatTitle = props?.CHAT_HEADER?.TITLE_TYPE?.GROUP_TEXT?.TEXT?.VALUE;
      return (
        <h1 aria-hidden="true" style={chatHeaderStyle} className="ebcss-chatbot-name accessibility-js ebcss-animated" title={chatTitle}>{chatTitle}</h1>
      );
    } else if(chatHeaderType === 'Logo') {
      chatTitleImg = props?.CHAT_HEADER?.TITLE_TYPE?.GROUP_LOGO?.LOGO?.VALUE;
      return (
        <img width="100%" height="100%" class="ebcss-client-logo ebcss-animated pe-2" src={chatTitleImg} alt="Chat Header" />
      );
    } else if(chatHeaderType === 'Both' && props?.CHAT_HEADER?.TITLE_TYPE?.GROUP_BOTH?.LOGO_FIRST?.VALUE) {
      chatTitle = props?.CHAT_HEADER?.TITLE_TYPE?.GROUP_BOTH?.TEXT?.VALUE;
      chatTitleImg = props?.CHAT_HEADER?.TITLE_TYPE?.GROUP_BOTH?.LOGO?.VALUE;
      return (
        <>
          <img width="100%" height="100%" class="ebcss-client-logo ebcss-animated pe-2" src={chatTitleImg} alt="Chat Header" />
          <h1 aria-hidden="true" style={chatHeaderStyle} className="ebcss-chatbot-name accessibility-js ebcss-animated" title={chatTitle}>{chatTitle}</h1>
        </>
      );
    } else if(chatHeaderType === 'Both') {
      chatTitle = props?.CHAT_HEADER?.TITLE_TYPE?.GROUP_BOTH?.TEXT?.VALUE;
      chatTitleImg = props?.CHAT_HEADER?.TITLE_TYPE?.GROUP_BOTH?.LOGO?.VALUE;
      return (
        <>
          <h1 aria-hidden="true" style={chatHeaderStyle} className="ebcss-chatbot-name accessibility-js ebcss-animated" title={chatTitle}>{chatTitle}</h1>
          <img width="100%" height="100%" class="ebcss-client-logo ebcss-animated pe-2" src={chatTitleImg} alt="Chat Header" />
        </>
      );
    }
    chatTitle = props?.CHAT_HEADER?.TEXT?.VALUE;
    return (
      <h1 aria-hidden="true" style={chatHeaderStyle} className="ebcss-chatbot-name accessibility-js ebcss-animated" title={chatTitle}>{chatTitle}</h1>
    );
  }

  let sendButtonIcon = props?.TEXT_INPUT_AREA?.SEND_ICON?.VALUE && (props.TEXT_INPUT_AREA.SEND_ICON.VALUE.indexOf('http') > -1) ? 
    <img className='ebcss-image ebcss-glyphicon-send' src={props?.TEXT_INPUT_AREA?.SEND_ICON?.VALUE ? props.TEXT_INPUT_AREA.SEND_ICON.VALUE : ''} alt='Send' style={sendButtonStyle} /> 
    : <i className={'eb-icons ' + (props?.TEXT_INPUT_AREA?.SEND_ICON?.VALUE ? props.TEXT_INPUT_AREA.SEND_ICON.VALUE : 'eb-send-icon-3')} style={sendButtonStyle}></i>

  // console.log('props -> ', props)

  return (
    <div role="main" id="ebcss-client-chat" className="col-lg-3 col-md-3 col-sm-12 col-xs-12 float-start ebcss-no-padding ebcss-new-window chat-wrapper-container">
      <div className="ebcss-header-wrapper ebcss-animated" style={{...themeStyleColor, 'color': '#ffffff'}}>
        {renderChatHeader()}
      </div>
      <div id="ebcss-main-chat-wrapper" className="ebcss-main-chat-wrapper" style={bodythemeObj}>
        <div id="ebcss-chat-area-wrapper" className="ebcss-chat-area-wrapper" style={{"height": "calc(100% - 85px)"}}>
          <div id="ebcss-chat-main-wrapper">
            <div id="ebcss-chat-area" className="ebcss-chat-area col-lg-12 col-md-12 col-sm-12 col-xs-12 float-start " style={{"padding-bottom": "6px"}}>
              {
                chatData.map((elm,i) => {
                  switch(elm.TYPE) {
                    case 'bot':
                      return (
                        <>
                          <div key={i} aria-live="polite" class="ebcss-message-wrapper ebcss-log-wrapper ebcss-bot col-lg-12 col-md-12 col-sm-12 float-start position-relative" >
                            { props?.CHAT_BOT_MESSAGE?.ICON?.VALUE ?
                              <div class="ebcss-client-icon">
                                <span role="alert"></span>
                                {
                                  props?.CHAT_BOT_MESSAGE?.ICON?.VALUE ? props.CHAT_BOT_MESSAGE.ICON.VALUE.indexOf('http') > -1 ? 
                                  <img className='ebcss-image ebcss-glyphicon-send' src={(props?.CHAT_BOT_MESSAGE?.ICON?.VALUE ? props.CHAT_BOT_MESSAGE.ICON.VALUE : props.CHAT_BOT_MESSAGE.AVATAR.VALUE)} alt='User' />
                                  :
                                  <i class={"eb-icons " + (props?.CHAT_BOT_MESSAGE?.ICON?.VALUE ? props.CHAT_BOT_MESSAGE.ICON.VALUE : props.CHAT_BOT_MESSAGE.AVATAR.VALUE)} style={{color: props.CHAT_BOT_MESSAGE.ICON_COLOR.VALUE}}></i>

                                  : props.CHAT_BOT_MESSAGE.AVATAR.VALUE.indexOf('http') > -1 ? 
                                  <img className='ebcss-image ebcss-glyphicon-send' src={(props?.CHAT_BOT_MESSAGE?.ICON?.VALUE ? props.CHAT_BOT_MESSAGE.ICON.VALUE : props.CHAT_BOT_MESSAGE.AVATAR.VALUE)} alt='User' />
                                  :
                                  <i class={"eb-icons " + (props?.CHAT_BOT_MESSAGE?.ICON?.VALUE ? props.CHAT_BOT_MESSAGE.ICON.VALUE : props.CHAT_BOT_MESSAGE.AVATAR.VALUE)} style={{color: props.CHAT_BOT_MESSAGE.ICON_COLOR.VALUE}}></i>
                                }
                              </div>
                              : ''
                            }
                            <span class="ebcss-message" style={botChatStyleObj}>
                              <span class="ebcss-arrow-left"></span>
                              {elm.MESSAGE}
                            </span>
                          </div>

                          <div key={i+'123'} id="ebcss-inline-suggestions" class={"ebcss-slider-section-wrapper ebcss-inline-suggestions" + ((props?.CHAT_BOT_MESSAGE?.ICON?.VALUE ? props.CHAT_BOT_MESSAGE.ICON.VALUE : (props?.CHAT_BOT_MESSAGE?.AVATAR?.VALUE ? props.CHAT_BOT_MESSAGE.AVATAR.VALUE : false)) ? " has-icon" : "")}>
                            <div class="ebcss-text-card-wrapper">
                              <div class="ebcss-text-card-set">
                                <div id="ebcss-suggestions" class="ebcss-card-wrapper ebcss-suggestions-wrapper">
                                  {
                                    elm.OPTIONS && elm.OPTIONS.length ? 
                                    elm.OPTIONS.map((element, k) => {
                                      return (
                                      <button tabindex="0" aria-label="Options" type="button" data-flowid="" class="ebcss-suggestion-message suggestion-accessibility accessibility-js ebcss-card" data-hidden="true" data={element} key={k} style={suggestionsChatStyleObj}>
                                        <a>{element}</a>
                                      </button>
                                      );
                                    }) : ''
                                  }
                                </div>
                              </div>
                            </div>
                          </div>
                        </>
                      )
                    case 'user':
                      return (
                        <div aria-hidden="true" class="ebcss-message-wrapper ebcss-log-wrapper ebcss-user col-lg-12 col-md-12 col-sm-12 float-start position-relative"  key={i}>
                          <span class="ebcss-message" style={userChatStyleObj}>
                            <span class="ebcss-arrow-right"></span>
                              {elm.MESSAGE}
                          </span>
                          { props?.USER_MESSAGE?.ICON?.VALUE ?
                            <div class="ebcss-client-icon">
                              <span role="alert"></span>
                              {
                                props?.USER_MESSAGE?.ICON?.VALUE ? props.USER_MESSAGE.ICON.VALUE.indexOf('http') > -1 ? 
                                <img className='ebcss-image ebcss-glyphicon-send' src={(props?.USER_MESSAGE?.ICON?.VALUE ? props.USER_MESSAGE.ICON.VALUE : props.USER_MESSAGE.AVATAR.VALUE)} alt='User' />
                                :
                                <i class={"eb-icons " + (props?.USER_MESSAGE?.ICON?.VALUE ? props.USER_MESSAGE.ICON.VALUE : props.USER_MESSAGE.AVATAR.VALUE)} style={{color: props.USER_MESSAGE.ICON_COLOR.VALUE}}></i>

                                : props.USER_MESSAGE.AVATAR.VALUE.indexOf('http') > -1 ? 
                                <img className='ebcss-image ebcss-glyphicon-send' src={(props?.USER_MESSAGE?.ICON?.VALUE ? props.USER_MESSAGE.ICON.VALUE : props.USER_MESSAGE.AVATAR.VALUE)} alt='User' />
                                :
                                <i class={"eb-icons " + (props?.USER_MESSAGE?.ICON?.VALUE ? props.USER_MESSAGE.ICON.VALUE : props.USER_MESSAGE.AVATAR.VALUE)} style={{color: props.USER_MESSAGE.ICON_COLOR.VALUE}}></i>
                              }
                            </div>
                            : ''
                          }
                        </div>
                      )
                    case 'agent':
                      return (
                        <div class="ebcss-message-wrapper ebcss-log-wrapper ebcss-agent col-lg-12 col-md-12 col-sm-12 float-start position-relative" key={i}>
                          { props?.AGENT_MESSAGE?.ICON?.VALUE ?
                            <div class="ebcss-client-icon">
                              <span role="alert"></span>
                              {
                                  props?.AGENT_MESSAGE?.ICON?.VALUE ? props.AGENT_MESSAGE.ICON.VALUE.indexOf('http') > -1 ? 
                                  <img className='ebcss-image ebcss-glyphicon-send' src={(props?.AGENT_MESSAGE?.ICON?.VALUE ? props.AGENT_MESSAGE.ICON.VALUE : props.AGENT_MESSAGE.AVATAR.VALUE)} alt='User' />
                                  :
                                  <i class={"eb-icons " + (props?.AGENT_MESSAGE?.ICON?.VALUE ? props.AGENT_MESSAGE.ICON.VALUE : props.AGENT_MESSAGE.AVATAR.VALUE)} style={{color: props.AGENT_MESSAGE.ICON_COLOR.VALUE}}></i>

                                  : props.AGENT_MESSAGE.AVATAR.VALUE.indexOf('http') > -1 ? 
                                  <img className='ebcss-image ebcss-glyphicon-send' src={(props?.AGENT_MESSAGE?.ICON?.VALUE ? props.AGENT_MESSAGE.ICON.VALUE : props.AGENT_MESSAGE.AVATAR.VALUE)} alt='User' />
                                  :
                                  <i class={"eb-icons " + (props?.AGENT_MESSAGE?.ICON?.VALUE ? props.AGENT_MESSAGE.ICON.VALUE : props.AGENT_MESSAGE.AVATAR.VALUE)} style={{color: props.AGENT_MESSAGE.ICON_COLOR.VALUE}}></i>
                                }
                            </div>
                            : ''
                          }
                          <span class="ebcss-message" style={agentChatStyleObj}>
                            <div class="ebcss-arrow-left"></div>
                              {elm.MESSAGE}
                          </span>
                        </div>
                      )
                    case 'notification':
                      return (
                        <div class="ebcss-message-wrapper ebcss-notification col-lg-12 col-md-12 col-sm-12 float-start position-relative" key={i}>
                          <span class="ebcss-message" style={{borderRadius: '4px'}}>{elm.MESSAGE}</span>
                          <span class="ebcss-horizontal-line"></span>
                        </div>
                      )
                  }
                })
              }
            </div>
          </div>
        </div>
        <div className="ebcss-messenger-footer" style={{}}>
          <div className="ebcss-text-input-wrapper col-lg-12 col-md-12 col-sm-12 col-xs-12 float-start " >
            <form id="ebcss-messageForm" className="position-relative speech-recognition-enabled" action="">
              <div className="ebcss-textarea-wrapper" style={inputChatStyleObj}>
                <label htmlFor="ebcss-m" style={{"opacity": 0,"position": "absolute","left": "-500px"}}></label>
                <textarea tabindex="0" aria-hidden="false" id="ebcss-m" className="ebcss-text-input-box accessibility-js" type="text" autocomplete="off" placeholder="Type or click on the microphone" maxlength="100" data-flowid="" style={textAreaStyleObj} on onChange={(e) => {setMsgLength(100 - e.target.value.length)}}></textarea>
                <label id="ebcss-characters-count" className="ebcss-characters" style={{display: "block", color: `${msgLength === 100 ? "rgb(204, 204, 204)" : "#000"}`, paddingLeft: '5px'}}>{msgLength}</label>
              </div>
              <button id="ebcss-speech-stop-btn" tabindex="0" aria-hidden="false" aria-label="Senden" className="ebcss-icon-btn ebcss-send-voice-btn speech-btn-container accessibility accessibility-js" type="button" value="Send">
                {sendButtonIcon}
              </button>
            </form>
          </div>
        </div>
      </div>
      <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 float-start position-absolute ebcss-powered-by-wrapper ebcss-animated">
        <div className="ebcss-powered-by-text">
          <div className="ebcss-powered-by ebcss-animated" aria-hidden="true" tabindex="-1" title="Powered By">Powered By</div>
          <a aria-hidden="true" tabindex="-1" className="ebcss-hyperlink ebcss-animated accessibility-href accessibility-js" target="_blank" href="https://www.enterprisebot.ai">
            <i className="eb-icons eb-enterprise-bot-logo-top ebcss-hyperlink-icon ebcss-animated" alt="Enterprise Bot Logo"></i>
          </a>
        </div>
      </div>
    </div>
  )
}
